/*
 * @Author: Gang Jiang 
 * @Date: 2024-10-08 11:54:23 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-11-26 11:17:57
 */
import client from './client';

export default {
  getList: (data) => {
    return client.get('user/console/list?' + Object.keys(data).map(key => {
      return `${key}=${data[key]}`
    }).join('&')).then(res => res.data);
  },
  changeStatus: data => {
    return client.post('user/switch/' + data.id + '/link-tool-status', data).then(res => res.data);
  },
  getLogList: (data) => {
    return client.get('user/log/list?' + Object.keys(data).map(key => {
      return `${key}=${data[key]}`
    }).join('&')).then(res => res.data);
  },
  getDetail: (id) => {
    return client.get('user/' + id).then(res => res.data);
  },
  getPhoneAreaCodeList: () => {
    return client.get('user/dict/country/calling/code').then(res => res.data);
  },
  getContentCategoryList: () => {
    return client.get('user/dict/content/category/list').then(res => res.data);
  },
  // 可用社交平台: http://116.62.11.65:8080/~m/#/apps/599/api/15/group/131?_k=7bbwc0
  getSocialPlatformsList: () => {
    return client.get('user/dict/social/platform/list').then(res => res.data);
  },
  getAudienceRegion: () => {
    return client.get('user/dict/audience/region/list').then(res => res.data);
  },
  changeReviewStatus: data => {
    return client.put('user/review', data).then(res => res.data);
  },
  saveRemark: data => {
    return client.put(`user/${data.id}/remark`, data).then(res => res.data);
  },
  // 博主邀请码列表
  invitationList: data => {
    return client.get('invitation/list?' + Object.keys(data).map(key => {
      return `${key}=${data[key]}`
    }).join('&')).then(res => res.data);
  },
  // 发送邀请邮件
  sendInvitationEmail: id => {
    return client.put(`invitation/send/email?influencerId=${id}`).then(res => res.data);
  },
  // 创建邀请
  createInvitation: data => {
    return client.post('invitation/code/create', data).then(res => res.data);
  },
  // 删除邀请
  deleteInvitation: id => {
    return client.delete(`invitation/code/delete?influencerId=${id}`).then(res => res.data);
  },
  setSocialPlatformInfo: (id, type, value) => {
    return client.put(`user/social-platform/${type === 'platformId' ? 'platform' : 'homepage'}`, { id, [type]: value }).then(res => res.data);
  },
  save: data => {
    return client.post('user/info/update', data).then(res => res.data);
  },
  getPaymentAccounts: (influencerId) => {
    return client
      .get(`user/${influencerId}/payment-account`)
      .then((res) => res.data);
  },
  getTaxInfo: (influencerId) => {
    return client.get(`user/${influencerId}/tax`).then((res) => res.data);
  },
  // /admin/influencer-marketing/v1/user/{influencerId}/payment-account/{accountId}/remark
  setRemark: (influencerId, accountId, text) => {
    return client.put(`user/${influencerId}/payment-account/${accountId}/remark`, { operatorRemark: text }).then((res) => res.data);
  },
  // /admin/influencer-marketing/v1/user/{influencerId}/payment-account/{accountId}/on
  togglePaymentAccount: (influencerId, accountId, active) => {
    return client.put(`user/${influencerId}/payment-account/${accountId}/${active ? 'on' : 'off'}`).then((res) => res.data);
  },
  /** 更新收款方式（开关、备注；关闭时可通知博主邮件，由后端处理 notifyInfluencer） */
  updatePaymentMethod: (influencerId, data) => {
    return client
      .put(`user/${influencerId}/payment/method`, data)
      .then((res) => res.data);
  },
}